if (!customElements.get('multicolumn-gallery')) {
  customElements.define(
    'multicolumn-gallery',
    class MulticolumnGallery extends HTMLElement {
      constructor() {
        super();
        this.lightbox = null;
        this._initAttempts = 0;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        if (this.lightbox) return;

        if (this.hasAttribute('data-gallery-disabled') || this.dataset.galleryDisabled === 'true') {
          return;
        }

        const PhotoSwipeLightbox =
          (window.FoxTheme && window.FoxTheme.PhotoSwipeLightbox) || window.PhotoSwipeLightbox;
        const PhotoSwipe = (window.FoxTheme && window.FoxTheme.PhotoSwipe) || window.PhotoSwipe;

        if (!PhotoSwipeLightbox || !PhotoSwipe) {
          if (this._initAttempts < 10) {
            this._initAttempts += 1;
            window.setTimeout(() => this.init(), 200);
          }
          return;
        }

        const triggers = Array.from(this.querySelectorAll('[data-mcg-zoom-trigger]'));
        if (!triggers.length) return;

        const dataSource = triggers
          .map((btn) => {
            const src = btn.getAttribute('data-pswp-src');
            const width = Number(btn.getAttribute('data-pswp-width'));
            const height = Number(btn.getAttribute('data-pswp-height'));
            if (!src || !width || !height) return null;
            return { src, width, height, mediaType: 'image' };
          })
          .filter(Boolean);

        if (!dataSource.length) return;

        this.lightbox = new PhotoSwipeLightbox({
          dataSource,
          pswpModule: PhotoSwipe,
          bgOpacity: 1,
        });

        triggers.forEach((btn, idx) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.lightbox) this.lightbox.loadAndOpen(idx);
          });
        });

        this.lightbox.init();
      }
    }
  );
}
